// extracted by mini-css-extract-plugin
export default {"quantityLabel":"styles_quantityLabel__jBXBa","iconTooltip":"styles_iconTooltip__n1D6X"};